var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "popover" }, [
    _c(
      "div",
      {
        attrs: { slot: "trigger" },
        on: { click: _vm.handleVisibilityPopover },
        slot: "trigger",
      },
      [_vm._t("trigger")],
      2
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpen,
            expression: "isOpen",
          },
        ],
        staticClass: "popover-content",
        style: "width: " + _vm.width + "px",
      },
      [_vm._t("content")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }